/* eslint-disable */
import {
  Avatar,
  Box,
  CircularProgress,
  Dialog,
  Grid,
  Slide,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TransitionProps } from "@mui/material/transitions";
import Images from "../../assets";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  communicationMessage,
  fetchAllMessages,
  seenMessageDetails,
} from "../../services";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
// import { addMessage, initMessages } from "../../store/Slices/messagesSlice";
import {
  Chat,
  Event,
  Message,
  Participant,
  Profile,
  ProfileInfo,
  TriggerObject,
} from "../../types/types";
// import { updateChat } from "../../store/Slices/chatsSlice";
import Socket from "../../assets/socket";
import { normalizeType, setWordCase } from "../../assets/library";
import { Close } from "@mui/icons-material";
import { addMessage, initMessages } from "../../store/slices/messagesSlice";
import { updateChat } from "../../store/slices/chatsSlice";

const Transition1 = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface props {
  open: boolean;
  setOpen: Function;
  id: string;
  type: "advisors" | "community";
}

const ChatContainer = ({ open, setOpen, id, type }: props) => {
  const profileInfo = useAppSelector((state) => state.profileInfo);
  const list = useRef<Message[]>([]);
  const [loading, setLoading] = useState(false);
  const messages = useAppSelector((state) => state.messages);
  const [uploadFiles, setUploadFiles] = useState<File[]>([])
  const chat = useAppSelector((state) => {
    let currentChats = state.chats;
    return type === "advisors"
      ? currentChats.data.advisors.find((chat) => chat._id === id)
      : currentChats.data.community.find((chat) => chat._id === id);
  });
  const dispatch = useAppDispatch();

  const participantDetails = chat?.participants.find(
    (user) => user._id !== profileInfo?.data?._id
  );
  console.log(participantDetails)

  const seenMessages = async () => {
    const response = await seenMessageDetails(id);
    // console.log(response)
    if (response.success) {
      dispatch(updateChat(response.data));
      if (
        profileInfo.data &&
        profileInfo.data._id &&
        Object.values(profileInfo.data).every(
          (item) => typeof item !== undefined
        )
      ) {
        let triggerObj: TriggerObject = {
          action: "seen",
          sender: { ...profileInfo.data, userType: "student" },
          recievers: chat?.participants.filter(
            (participant: Participant) =>
              participant._id !== profileInfo.data?._id
          ),
          data: response.data,
        };
        Socket.emit("trigger", triggerObj);
      }
    }
  };

  const triggerMessages = (triggerObject: TriggerObject) => {
    switch (triggerObject.action) {
      case "send":
        //console.log("message send trigger",triggerObject.data.message)
        dispatch(addMessage({ ...triggerObject.data.message, type: "normal" }));
        seenMessages();
        break;

      case "typing":
        //triggerObject.data=="start"?dispatch(startTypingMessage({...triggerObject.sender,activity:'typing'})):dispatch(stopTypingMessage({...triggerObject.sender,activity:"inchat"}))
        break;

      case "seen":
        //dispatch(seenMessage({...triggerObject.sender,activity:"inchat"}))
        break;
    }
  };

  const fetchMessage = async () => {
    try {
      setLoading(true);
      const response = await fetchAllMessages(id);
      if (response) {
        let msgs = response.data.map((msg: Message) => ({
          ...msg,
          type: "normal",
        }));
        msgs.reverse();
        dispatch(
          initMessages({
            requestStatus: "initiated",
            responseStatus: "recieved",
            haveAnIssue: false,
            issue: "",
            data: msgs,
          })
        );
        if (
          chat?.unSeenMessages
            .filter(
              (msg: any) => msg.message.sender._id !== profileInfo.data?._id
            )
            .filter(
              (recievedMessage: any) =>
                !recievedMessage.seen.find(
                  (id: string) => id === profileInfo.data?._id
                )
            ).length != 0
        ) {
          await seenMessages();
        }
      }
      setLoading(false);
    } catch (error) {}
  };

  const bakeMessages = (messages: Message[], chat: Chat, user: Profile) => {
    let unsetParticipants = chat.participants.filter(
      (chat) => chat._id != user._id
    );
    let list: Message[] = [];
    let seenParticipants: Participant[] = [];
    let unseenParticipants: Participant[] = [];
    messages.reverse();
    messages.forEach((msg) => {
      if (msg.sender?._id == user._id) {
        if (unsetParticipants.length != 0) {
          if (chat.unSeenMessages.length == 0) {
            if (unsetParticipants.length != 0) {
              seenParticipants = [...unsetParticipants];
            }
          } else {
            if (
              !chat.unSeenMessages.find(
                (unseenMsg) => unseenMsg.message._id == msg._id
              )
            ) {
              seenParticipants = [...unsetParticipants];
            } else {
              seenParticipants = unsetParticipants.filter((unsetParticipant) =>
                chat.unSeenMessages
                  .find((unseenMsg) => unseenMsg.message._id == msg._id)
                  ?.seen.find(
                    (seenParticipant) => seenParticipant == unsetParticipant._id
                  )
              );
            }
          }
          if (seenParticipants.length != 0) {
            let seenMessage = seenParticipants.reduce(
              (message, seenParticipant) =>
                message + seenParticipant.firstName + " , ",
              "Seen by "
            );
            list.push({
              _id: msg._id + "_seen",
              type: "seen",
              content: seenMessage.substring(0, seenMessage.length - 3),
              chat: chat._id,
            });
          }
          list.push(msg);
          unsetParticipants = unsetParticipants.filter(
            (unsetParticipant) =>
              !seenParticipants.find(
                (seenParticipant) => seenParticipant._id == unsetParticipant._id
              )
          );
        } else {
          list.push(msg);
        }
      } else {
        list.push(msg);
      }
    });
    list.reverse();
    let typingParticipants = chat.participants.filter(
      (participant) => participant.activity == "typing"
    );
    //console.log("Typing",typingParticipants)
    if (typingParticipants.length != 0) {
      let typingMessage = typingParticipants.reduce(
        (msg, participant) => participant.firstName + " , ",
        ""
      );
      list.push({
        _id: chat._id + "_typing",
        type: "typing",
        content:
          typingMessage.substring(0, typingMessage.length - 3) +
          (typingParticipants.length == 1 ? " is typing" : " are typing"),
        chat: chat._id,
        sender: {
          displayPicSrc: "",
          firstName: "",
          lastName: "",
          email: "",
          _id: chat._id + "_typing",
          userType: "",
        },
      });
      //console.log(list)
    }
    return list;
    //let bakedParticipants=getParticipantsLastSeenMessage(chat,user,messages);
    //return bakeMessagesWithSeenInfo(messages,bakedParticipants);
  };

  
  const eventHandler = async(event:Event) =>{
    let triggerObj:TriggerObject 
    switch(event.name){
      case "send":
        const formData = new FormData();
        formData.append("content", event.data);
        formData.append("chatId", id);
        let totalSize = 0;
      
        if (uploadFiles.length > 0) {
          const allowedFileTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ];
      
          const validFiles = uploadFiles.filter((file) => {
            const isValidType = allowedFileTypes.includes(file?.type);
            const isValidSize = file?.size <= 16 * 1024 * 1024;
            
            if (!isValidType || !isValidSize) {
              // console.log(`File "${file?.name}" is not allowed or exceeds 16MB.`);
            }
      
            return isValidType && isValidSize;
          });
      
          if (validFiles.length === 0 && !event.data) {
            // console.error("No valid files selected and no message content.");
            return;
          }
      
          validFiles.forEach((file) => {
            formData.append("uploaded_file", file);
            totalSize += file.size;
          });
        }
      
        try {
          if (event.data !== "" || totalSize > 0) {
            const response = await communicationMessage(formData);
            if (response.data.success) {
              dispatch(updateChat(response.data.data.chat));
              dispatch(addMessage(response.data.data.message));
              triggerObj = {
                action: "send",
                sender: { ...profileInfo.data, userType: "student" },
                recievers: chat?.participants.filter(
                  (participant) => participant._id !== profileInfo.data?._id
                ),
                data: response.data.data,
              };
              Socket.emit("trigger", triggerObj);
              setUploadFiles([])

            } else {
              // console.error("Failed to send message or upload files.");
            }
          }
        } catch (error) {
          // console.error("Error during file upload or message sending:", error);
        }
        break;
        case "startTyping":
          triggerObj={
            action:"typing",
            sender:{...profileInfo.data,userType:"student"},
            recievers:chat?.participants.filter((participant)=>participant._id!=profileInfo.data?._id),
            data:"start"
        }
        Socket.emit("trigger",triggerObj);
          break;
        case "stopTyping":
          triggerObj={
            action:"typing",
            sender:{...profileInfo.data,userType:"student"},
            recievers:chat?.participants.filter((participant)=>participant._id!=profileInfo.data?._id),
            data:"stop"
        }
        Socket.emit("trigger",triggerObj);
          break;  
    }
  }

  useEffect(() => {
    // if (id) {
      Socket.removeListener("trigger", triggerMessages);
      Socket.on("trigger", triggerMessages);
      fetchMessage();
      return ()=>{Socket.removeListener("trigger", triggerMessages)}
    // }
  }, []);

  list.current =
    chat && profileInfo.data
      ? bakeMessages([...messages.data], chat, profileInfo.data)
      : [];
  const Header = () => {
    return (
      <div
        style={{ background: "#F8F8FC", padding: "0.5rem",borderRadius:"0.8rem",position:"relative" }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            // component="img"
            src={participantDetails?.displayPicSrc}
            alt="profile"
            sx={{ width: "3rem", height: "3rem", borderRadius: "50%" }}
          />
          <Typography fontWeight="500" sx={{position:"absolute",right:"10px",top:"-1rem",background:"#fff",p:1,borderRadius:"10px",
            color:participantDetails?.role === "counsellor" ? "#3B3F76": participantDetails?.role === "processCoordinator" ? "#569228" :"#FEB853",fontSize:"14px"}}> 
            {participantDetails?.role ? normalizeType(participantDetails?.role) : participantDetails?.role}
            </Typography>
          <Box>
            <Typography fontWeight="500">
              {setWordCase(participantDetails?.firstName)}
              &nbsp;{setWordCase(participantDetails?.lastName)}
            </Typography>
          </Box>
        </Stack>
      </div>
    );
  };
  const Content = () => {
    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      scrollToBottom();
    });
  
    const scrollToBottom = () => {
      if (bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    };

    return (
      <Box
        sx={{
          overflowY: "scroll",
          mt: 3,
          height: "390px",
          "&::-webkit-scrollbar": {
            width: "12px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "transparent",
            borderRadius: "8px",
          },
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div className="chat-container" ref={bottomRef}>
            {list.current.length > 0 ? 
          <>
            {list.current.map((message: any) => (
              <>
                {message.type !== "seen" && message.type !== "typing" ? (
                  <div
                    key={message._id}
                    className={`message ${
                      message?.sender?._id === profileInfo.data?._id
                        ? "sent"
                        : "received"
                    }`}
                  >
                    {message.content}
                    {message?.document?.data?.preview_url?
                    // auto | none | visiblePainted | visibleFill | visibleStroke | visible | painted | fill | stroke | all | inherit
                    <iframe src={message?.document?.data?.preview_url} title="preview" style={{pointerEvents:"painted"}} scrolling="yes"/>
                    :""}
                    <Avatar
                      src={message.sender?.displayPicSrc}
                      alt=""
                      sx={
                        message?.sender?._id === profileInfo.data?._id
                          ? {
                              width: "1.5rem",
                              height: "1.5rem",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "-12px",
                              right: 0,
                            }
                          : {
                            width: "1.5rem",
                            height: "1.5rem",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "-12px",
                            left: 0,
                          }
                      }
                    />
                  </div>
                ) : (
                  <div className="seenMsg">{message.content}</div>
                )}
              </>
            ))}
          </> :
          <Typography textAlign="center">Start chat</Typography> 
          }
          
          </div>
        )}
      </Box>
    );
  };
  const Footer = (props:any) => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event:any) => {
    const selectedFiles = Array.from(event.target.files);
    setUploadFiles(selectedFiles as File[]);
    console.log(selectedFiles)
  };
  const removeFile = (index:any) => {
    const updatedFiles = [...uploadFiles];
    updatedFiles.splice(index, 1);
    setUploadFiles(updatedFiles);
  };

    const handleSend = async () => {
      try {
        if(content !== "" || uploadFiles !== null){
          setLoading(true);
          await props.eventHandler({name:"send",data:content})
        }
      } catch (error) {}
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter" && !event.shiftKey && content.trim() !== "") {
        event.preventDefault();
        handleSend();
      }
    };

    return (
      <div style={{position:"relative"}}>
           {uploadFiles?.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',position: "absolute",
            top: "-44px",
            right: "35%", }}>
            <div style={{ width: 'fitContent' }}>
              <Typography fontSize="0.9rem">Selected files:</Typography>
              <ul style={{ listStyle: 'none',padding:0,margin:0 }}>
                {uploadFiles.map((file, index) => (
                  <li style={{ fontSize: '12px', display: 'flex' }} key={index}>
                    {file.name}
                    <Close onClick={() => removeFile(index)} sx={{fontSize:"1rem",cursor:"pointer"}} />
                  </li>
                ))}
              </ul>
            </div>

          </div>
        )}
        <Grid container sx={{background: "#F8F8FC",padding:"0.5rem",borderRadius:"0.8rem" }}>
          <Grid item xs={12} >
       
          </Grid>
          <Grid
            item
            xs={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <input
                type="file"
                multiple
                style={{ display: 'none' }}
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              <DescriptionIcon sx={{ color: "",cursor:"pointer" }} onClick={() => fileInputRef?.current?.click()}/>

            </div>
          </Grid>
          
          <Grid item xs={9.5}>
            <TextField
              variant="outlined"
              size="small"
              onFocus={()=>props.eventHandler({name:"startTyping"})}
              onBlur={()=>props.eventHandler({name:"stopTyping"})}
              multiline
              maxRows={1}
              fullWidth
              value={content}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: 0,
                  "&:Focus": {
                    border: 0,
                  },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                },
              }}
              onChange={(e) => setContent(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </Grid>
          <Grid
            item
            xs={1.5}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background:"#fff", borderRadius: "6px" 
            }}
          >
            {loading ? (
              <img
                src={Images.standardLoader}
                alt="loader"
                style={{ width: "1rem" }}
              />
            ) : (
              <img
                src={Images.sendIcon}
                alt="sendIcon"
                style={{ width: "2rem",height: "2rem"}}
                onClick={handleSend}
              />
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        sx={{
          right: "0",
          left: { md: "45%", xs: "0", lg: "68%" },
          top: { md: "10px", xs: "0", lg: "25px" },
        }}
        PaperProps={{
          style: {
            borderRadius: "1rem",
            padding: "1rem",
            width: "410px",
            height: "560px",
            // background: "#EDF2F6",
          },
        }}
        TransitionComponent={Transition1}
        keepMounted
        onClose={() => setOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <KeyboardArrowDownIcon
            sx={{
              position: "absolute",
              top: 0,
              color: "#0F0F0F",
              fontSize: "2rem",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => setOpen(false)}
          />
        </Box>
        <Box sx={{ mt: 3 }}>
          <Header />
          <Content />
          <Footer eventHandler={eventHandler}/>
        </Box>
      </Dialog>
    </div>
  );
};

export default ChatContainer;
